import { render, staticRenderFns } from "./FormSoftSaleStockItem.vue?vue&type=template&id=285963ae"
import script from "./FormSoftSaleStockItem.vue?vue&type=script&lang=js"
export * from "./FormSoftSaleStockItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormSoftSaleStockItem.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('285963ae')) {
      api.createRecord('285963ae', component.options)
    } else {
      api.reload('285963ae', component.options)
    }
    module.hot.accept("./FormSoftSaleStockItem.vue?vue&type=template&id=285963ae", function () {
      api.rerender('285963ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormSoftSaleStockItem.vue"
export default component.exports